<template>
  <fa-icon icon="edit" />
</template>
